/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Ai_Chat_Steps_SummaryInputs */

const en_admin_ai_chat_steps_summary = /** @type {(inputs: Admin_Ai_Chat_Steps_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Worked`)
};

const de_admin_ai_chat_steps_summary = /** @type {(inputs: Admin_Ai_Chat_Steps_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gearbeitet`)
};

const es_admin_ai_chat_steps_summary = /** @type {(inputs: Admin_Ai_Chat_Steps_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabajó`)
};

const fr_admin_ai_chat_steps_summary = /** @type {(inputs: Admin_Ai_Chat_Steps_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A travaillé`)
};

const nl_admin_ai_chat_steps_summary = /** @type {(inputs: Admin_Ai_Chat_Steps_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewerkt`)
};

/** @type {(inputs: Admin_Ai_Chat_Steps_SummaryInputs) => LocalizedString} */
const it_admin_ai_chat_steps_summary = en_admin_ai_chat_steps_summary;

/** @type {(inputs: Admin_Ai_Chat_Steps_SummaryInputs) => LocalizedString} */
const pt_br2_admin_ai_chat_steps_summary = en_admin_ai_chat_steps_summary;

/** @type {(inputs: Admin_Ai_Chat_Steps_SummaryInputs) => LocalizedString} */
const pl_admin_ai_chat_steps_summary = en_admin_ai_chat_steps_summary;

/** @type {(inputs: Admin_Ai_Chat_Steps_SummaryInputs) => LocalizedString} */
const hu_admin_ai_chat_steps_summary = en_admin_ai_chat_steps_summary;

/** @type {(inputs: Admin_Ai_Chat_Steps_SummaryInputs) => LocalizedString} */
const ro_admin_ai_chat_steps_summary = en_admin_ai_chat_steps_summary;

/**
* | output |
* | --- |
* | "Worked" |
*
* @param {Admin_Ai_Chat_Steps_SummaryInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_steps_summary = /** @type {((inputs?: Admin_Ai_Chat_Steps_SummaryInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_Steps_SummaryInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_steps_summary(inputs)
	if (locale === "de") return de_admin_ai_chat_steps_summary(inputs)
	if (locale === "es") return es_admin_ai_chat_steps_summary(inputs)
	if (locale === "fr") return fr_admin_ai_chat_steps_summary(inputs)
	if (locale === "nl") return nl_admin_ai_chat_steps_summary(inputs)
	if (locale === "it") return it_admin_ai_chat_steps_summary(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_steps_summary(inputs)
	if (locale === "pl") return pl_admin_ai_chat_steps_summary(inputs)
	if (locale === "hu") return hu_admin_ai_chat_steps_summary(inputs)
	return ro_admin_ai_chat_steps_summary(inputs)
});
export { admin_ai_chat_steps_summary as "admin.ai_chat.steps_summary" }